"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _axios = _interopRequireDefault(require("axios"));

var _react = _interopRequireWildcard(require("react"));

var _antd = require("antd");

var _icons = require("@ant-design/icons");

var _DataDisplayWidget = _interopRequireDefault(require("../../MathResponse/Style/DataDisplayWidget"));

var _moment = _interopRequireDefault(require("moment"));

var _DateConstant = require("../../../../../constants/DateConstant");

var _config = _interopRequireDefault(require("../../../../../config.json"));

var _RmName = _interopRequireDefault(require("../../../../../RmName.json"));

var _utils = _interopRequireDefault(require("../../../../../utils"));

var _TableData = _interopRequireDefault(require("./TableData"));

var _errorPage = _interopRequireDefault(require("./../../../../error-views/errorPage"));

var _CardData = _interopRequireDefault(require("./CardData"));

var innerwidth = window.innerWidth;
var Option = _antd.Select.Option;
var todayDate = new Date();
var year = todayDate.getFullYear();
var month = ("0" + (todayDate.getMonth() + 1)).slice(-2);
var day = ("0" + todayDate.getDate()).slice(-2);
var today = "".concat(year, "-").concat(month, "-").concat(day);

var MathMorning = function MathMorning() {
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      apiError = _useState4[0],
      setapiError = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      data = _useState6[0],
      setData = _useState6[1];

  var _useState7 = (0, _react.useState)([]),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      allData = _useState8[0],
      setAllData = _useState8[1];

  var _useState9 = (0, _react.useState)(today),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      date = _useState10[0],
      setDate = _useState10[1];

  var _useState11 = (0, _react.useState)(""),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      rmCode = _useState12[0],
      setRmCode = _useState12[1];

  var _useState13 = (0, _react.useState)([]),
      _useState14 = (0, _slicedToArray2.default)(_useState13, 2),
      rmList = _useState14[0],
      setRmList = _useState14[1]; // useEffect(async () => {
  //     let url = config.getMathMorning + cl;
  //     axios.get(url, { headers: { 'Authorization': token } })
  //         .then(resp => {
  //             if (resp.data.status === "error") setapiError(resp.data);
  //             else{
  //                 resp.data.map(d2 => {
  //                     if (d2.sendDate) {
  //                         let convertDate = dateFormate(d2.sendDate)
  //                         d2.sendDate = convertDate
  //                     }
  //                 });
  //                 let details = resp.data.filter(item => item.sendDate === today);
  //                 let rmList = resp.data.reduce((unique, o) => {
  //                     if (!unique.some(obj => obj.RM_code === o.RM_code)) {
  //                         unique.push(o);
  //                     }
  //                     return unique;
  //                 }, []);
  //                 setRmList(rmList);
  //                 setAllData(resp.data)
  //                 setData(details);
  //                 setLoading(false)
  //             }
  //         }, error => {
  //             let obj={"status":"error","message":"Network Error"};
  // 			if(error.response) setapiError(error.response);
  // 		   else setapiError(obj);
  //         })
  // }, []);


  (0, _react.useEffect)(function () {
    function fatchData() {
      return _fatchData.apply(this, arguments);
    }

    function _fatchData() {
      _fatchData = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var url;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                url = _config.default.getMathMorning + cl;

                _axios.default.get(url, {
                  headers: {
                    'Authorization': token
                  }
                }).then(function (resp) {
                  if (resp.data.status === "error") setapiError(resp.data);else {
                    resp.data.map(function (d2) {
                      if (d2.sendDate) {
                        var convertDate = dateFormate(d2.sendDate);
                        d2.sendDate = convertDate;
                      }

                      return d2.sendDate;
                    });
                    var details = resp.data.filter(function (item) {
                      return item.sendDate === today;
                    });

                    var _rmList = resp.data.reduce(function (unique, o) {
                      if (!unique.some(function (obj) {
                        return obj.RM_code === o.RM_code;
                      })) {
                        unique.push(o);
                      }

                      return unique;
                    }, []);

                    setRmList(_rmList);
                    setAllData(resp.data);
                    setData(details);
                    setLoading(false);
                  }
                }, function (error) {
                  var obj = {
                    "status": "error",
                    "message": "Network Error"
                  };
                  if (error.response) setapiError(error.response);else setapiError(obj);
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _fatchData.apply(this, arguments);
    }

    fatchData();
  }, [cl, token]);

  function dateFormate(changeDate) {
    var date = new Date(changeDate);
    var year = date.getFullYear();
    var month = ("0" + (date.getMonth() + 1)).slice(-2);
    var day = ("0" + date.getDate()).slice(-2);
    var todayDate = "".concat(year, "-").concat(month, "-").concat(day);
    return todayDate;
  }

  function _onChange(dateString) {
    var filterDate = showTableData("rmFilter");
    var date = dateString;
    setDate(date);
    var filterDateData = filterDate.filter(function (item) {
      return item.sendDate === dateString;
    });
    setData(filterDateData);
  }

  var SelectRM = function SelectRM(value) {
    var filterDate = showTableData("dateFilter");
    setRmCode(value);

    if (value !== 'All') {
      var key = 'RM_code';

      var details = _utils.default.filterArray(filterDate, key, value);

      setData(details);
    } else {
      setData(filterDate);
    }
  };

  function showTableData(value) {
    var allDetails = [];

    if (value === "dateFilter") {
      if (date !== "") {
        var filterDateData = allData.filter(function (obj) {
          return obj.sendDate === date;
        });
        allDetails = filterDateData;
      } else allDetails = allData;
    }

    if (value === "rmFilter") {
      if (rmCode !== "") {
        var key = 'RM_code';

        var details = _utils.default.filterArray(allData, key, rmCode);

        allDetails = details;
      } else allDetails = allData;
    }

    return allDetails;
  }

  return apiError ? /*#__PURE__*/_react.default.createElement(_errorPage.default, {
    details: apiError
  }) : loading ? /*#__PURE__*/_react.default.createElement(_antd.Spin, {
    tip: "Loading..."
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [8, 8]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 20,
    xl: 20,
    xxl: 20
  }, /*#__PURE__*/_react.default.createElement(_antd.Card, {
    title: "Filter"
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 10,
    xl: 10,
    xxl: 10
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 10,
    sm: 10,
    md: 10,
    lg: 8,
    xl: 8,
    xxl: 8,
    className: "mt-2"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Filter By Date:")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 14,
    sm: 14,
    md: 14,
    lg: 16,
    xl: 16,
    xxl: 16
  }, /*#__PURE__*/_react.default.createElement(_antd.DatePicker, {
    defaultValue: (0, _moment.default)(todayDate, _DateConstant.DATE_FORMAT_YYYY_MM_dd_Combined),
    onChange: function onChange(momentDate, dateString) {
      return _onChange(dateString);
    },
    placeholder: "Select Date"
  })))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 12,
    xl: 12,
    xxl: 12
  }, /*#__PURE__*/_react.default.createElement(_antd.Row, {
    gutter: [4, 4]
  }, /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 10,
    sm: 10,
    md: 10,
    lg: 5,
    xl: 5,
    xxl: 5,
    className: "mt-2"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Filter By ".concat(_RmName.default.name), ":")), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 14,
    sm: 14,
    md: 14,
    lg: 19,
    xl: 19,
    xxl: 19
  }, /*#__PURE__*/_react.default.createElement(_antd.Select, {
    showSearch: true,
    style: {
      width: 150
    },
    placeholder: "Search or Select RM Code",
    optionFilterProp: "children",
    filterOption: function filterOption(input, option) {
      return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    filterSort: function filterSort(optionA, optionB) {
      return optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase());
    },
    onChange: SelectRM
  }, /*#__PURE__*/_react.default.createElement(Option, {
    key: "All",
    value: "All"
  }, "All"), rmList.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: item.RM_code,
      value: item.RM_code
    }, item.RM_code);
  })))))))), /*#__PURE__*/_react.default.createElement(_antd.Col, {
    xs: 24,
    sm: 24,
    md: 24,
    lg: 4,
    xl: 4,
    xxl: 4
  }, /*#__PURE__*/_react.default.createElement(_DataDisplayWidget.default, {
    icon: /*#__PURE__*/_react.default.createElement(_icons.UserSwitchOutlined, null),
    value: data.length,
    title: "Total ".concat(_RmName.default.name),
    color: "cyan",
    size: "20",
    vertical: true,
    avatarSize: 30,
    style: {
      height: 132
    }
  }))), data.length > 0 ? innerwidth > 425 ? /*#__PURE__*/_react.default.createElement(_TableData.default, {
    data: data
  }) : /*#__PURE__*/_react.default.createElement(_CardData.default, {
    data: data
  }) : /*#__PURE__*/_react.default.createElement(_antd.Card, null, /*#__PURE__*/_react.default.createElement(_antd.Empty, null)));
};

var _default = MathMorning;
exports.default = _default;